import local from './etc/local.json';
import qa from './etc/qa.json';
import prod from './etc/prod.json';
import * as _ from "lodash";

export function getProfile() {
    const {profile} = extractProfile(import.meta.env?.MODE || process.env.NEXT_PUBLIC_PROFILE)
    return profile ?? (typeof window === "undefined" ? process.env.PB_PROFILE : null);
}

function getServiceProfile(){
    const {svcProfile} = extractProfile(import.meta.env?.MODE || process.env.NEXT_PUBLIC_PROFILE)
    return svcProfile ?? (typeof window === "undefined" ? process.env.SVC_PROFILE : process.env.NEXT_PUBLIC_SVC_PROFILE);
}

export function extractProfile(profileString) {
    if (!profileString) return { profile: null, svcProfile: null };

    const parts = profileString.split('-');
    return {
        profile: parts[0],
        svcProfile: parts.length > 1 ? parts[1] : null
    };
}

export function getConfig(profile, svcProfile) {
    profile = profile || getProfile()
    svcProfile = svcProfile || getServiceProfile()

    let cfg;
    if (profile === "qa") {
        cfg = qa;
    } else if (profile === "prod") {
        cfg = prod;
    } else if (profile === "prod:dev") {
        const localProd = _.cloneDeep(prod)
        localProd.poln.redirect_sign_in = local.poln.redirect_sign_in
        localProd.poln.redirect_sign_out = local.poln.redirect_sign_out
        cfg = localProd
    } else {
        cfg = local;
    }

    if (svcProfile) {
        cfg = _.cloneDeep(cfg)
        cfg.siteApi.apiUrl = `${cfg.siteApi.apiUrl}/${svcProfile}`
        if (profile !== 'local') {
            cfg.poln.poln_api_base_url = `${cfg.poln.poln_api_base_url}/${svcProfile}`
        }
        cfg.datadyno.poln_api_base_url = `${cfg.datadyno.poln_api_base_url}/${svcProfile}`
        cfg.datadyno.app_origin = cfg.datadyno.app_origin.replace('app', `${profile}-${svcProfile}-app`)
        cfg.datadyno.connect_api_base_url = cfg.datadyno.connect_api_base_url.replace(profile, `${profile}-${svcProfile}`)
        cfg.datadyno.web_socket_url = cfg.datadyno.web_socket_url.replace(profile, `${profile}-${svcProfile}`)

        if(typeof window === "undefined" || (typeof window !== 'undefined' &&
            !(window.location.hostname.startsWith('app.') || window.location.hostname.startsWith('qa-app.')))){
            cfg.datadyno.redirect_sign_in = cfg.datadyno.redirect_sign_in.replace(`${profile}-app`, 'app').replace('app', `${profile}-${svcProfile}-app`)
            cfg.datadyno.redirect_sign_out = cfg.datadyno.redirect_sign_out.replace(`${profile}-app`, 'app').replace('app', `${profile}-${svcProfile}-app`)

        }
    }

    if (typeof window === 'undefined') {
        //console.log(`config from ${profile}-${svcProfile}`)
    }

    return cfg;
}


export const cfg = getConfig();




